var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_1024)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9888 15.7707C23.845 15.2294 23.4215 14.8031 22.8837 14.6584C21.9089 14.3955 18 14.3955 18 14.3955C18 14.3955 14.0912 14.3955 13.1163 14.6584C12.5785 14.8031 12.155 15.2294 12.0112 15.7707C11.75 16.7518 11.75 18.7989 11.75 18.7989C11.75 18.7989 11.75 20.846 12.0112 21.8271C12.155 22.3684 12.5785 22.777 13.1163 22.9217C14.0912 23.1846 18 23.1846 18 23.1846C18 23.1846 21.9088 23.1846 22.8837 22.9217C23.4215 22.777 23.845 22.3684 23.9888 21.8271C24.25 20.846 24.25 18.7989 24.25 18.7989C24.25 18.7989 24.25 16.7518 23.9888 15.7707ZM16.7216 20.6575V16.9403L19.9886 18.799L16.7216 20.6575Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.79004,
    width: 34,
    height: 34,
    rx: 17,
    stroke: "white",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_1024"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 9,
    fill: "white",
    transform: "translate(11.5 14.29)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.ca5e8c8312be53a6b0e8fa5217ce5de2.svg";
export { ForwardRef as ReactComponent };